import React, { Component } from 'react';

class IconSidebarParentMasterData extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
            >
                <path
                    fill={this.props.isActive ? "#26A" : "#fff"}
                    d="M21.129 12.779H2.87a.862.862 0 01-.871-.86V2.86c0-.478.387-.86.871-.86H21.13c.484 0 .871.382.871.86v9.059c0 .468-.387.86-.871.86zm-17.387-1.72h16.515V3.72H3.742v7.339z"
                ></path>
                <path
                    fill={this.props.isActive ? "#26A" : "#fff"}
                    d="M6.404 8.995c.9-.01 1.627-.736 1.617-1.625 0-.879-.736-1.596-1.626-1.596h-.01c-.9.01-1.626.736-1.626 1.625.01.879.736 1.596 1.636 1.596h.01zM11.06 8.995c.901-.01 1.627-.736 1.617-1.625a1.62 1.62 0 00-1.636-1.596h-.01c-.9.01-1.626.736-1.616 1.625.01.879.736 1.596 1.636 1.596h.01zM21.129 22H2.87A.862.862 0 012 21.14v-9.059c0-.478.387-.86.871-.86H21.13c.484 0 .871.382.871.86v9.059c0 .468-.387.86-.871.86zM3.742 20.28h16.515v-7.339H3.742v7.339z"
                ></path>
                <path
                    fill={this.props.isActive ? "#26A" : "#fff"}
                    d="M6.405 18.216c.9-.01 1.626-.736 1.616-1.625a1.62 1.62 0 00-1.636-1.595h-.01c-.9.01-1.626.735-1.616 1.624.01.88.736 1.596 1.636 1.596h.01zM11.06 18.216c.901-.01 1.627-.736 1.617-1.625a1.62 1.62 0 00-1.636-1.595h-.01c-.9.01-1.626.735-1.616 1.624.01.88.736 1.596 1.636 1.596h.01z"
                ></path>
            </svg>
        );
    }
}

export default IconSidebarParentMasterData;